import { act } from "react";
import actions from "./actions";

const initState = {
    readPublicContactState: null,
    updatePublicContactState: null,
    contact: {},
    company: {},
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.READ_PUBLIC_CONTACT_PROFILE_REQUEST:
            return {
                ...state,
                readPublicContactState: 'request',
            };
        case actions.READ_PUBLIC_CONTACT_PROFILE_SUCCESS:
            return {
                ...state,
                contact: action.contact,
                company: action.company,
                readPublicContactState: 'success',
            };
        case actions.READ_PUBLIC_CONTACT_PROFILE_ERROR:
            return {
                ...state,
                readPublicContactState: 'error',
            };
        case actions.UPDATE_PUBLIC_CONTACT_PROFILE_REQUEST:
            return {
                ...state,
                updatePublicContactState: 'request',
            };
        case actions.UPDATE_PUBLIC_CONTACT_PROFILE_SUCCESS:
            return {
                ...state,
                updatePublicContactState: 'success',
            };
        case actions.UPDATE_PUBLIC_CONTACT_PROFILE_ERROR:
            return {
                ...state,
                updatePublicContactState: 'error',
            };
        default:
            return state;
    }
}